import React from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Navigate } from "react-router-dom";
import ProfileCheck from "./ProfileCheck";

interface ProtectedRouteProps {
  children: React.ReactNode;
  skipProfileCheck?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  skipProfileCheck = false,
}) => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  // Check for tokens in sessionStorage as fallback
  const hasStoredTokens =
    sessionStorage.getItem("access_token") &&
    sessionStorage.getItem("id_token");

  console.log("ProtectedRoute: authStatus =", authStatus);
  console.log("ProtectedRoute: skipProfileCheck =", skipProfileCheck);
  console.log("ProtectedRoute: hasStoredTokens =", hasStoredTokens);

  if (authStatus === "authenticated" || hasStoredTokens) {
    // Skip profile check for certain routes like profile setup
    if (skipProfileCheck) {
      console.log("ProtectedRoute: Skipping profile check, rendering children");
      return <>{children}</>;
    }

    // Check if user has completed profile setup
    console.log("ProtectedRoute: Running profile check");
    return <ProfileCheck>{children}</ProfileCheck>;
  }

  console.log("ProtectedRoute: Not authenticated, redirecting to /");
  return <Navigate to="/" replace />;
};

export default ProtectedRoute;
